export default function CartNotFound() {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h4>Der Warenkorb ist leer</h4>
    </div>
  );
}
